import React from 'react'

import cx from 'classnames'

import Breadcrumb from '../Breadcrumb'

import utilityStyles from '../../styles/utility.module.css'
import styles from './styles.module.css'

export interface Navigation {
  link?: string
  title?: string
}

interface Props {
  header: React.ReactNode
  content: React.ReactNode
  containerClassName?: string
  contentClassName?: string
  headerTextClassName?: string
  title?: string
  showSearch?: boolean
  navigation?: Navigation
}

export const Header: React.FC<Props> = ({
  header,
  content,
  containerClassName,
  headerTextClassName,
  contentClassName,
  navigation,
  title,
  ...rest
}) => {
  return (
    <section className={cx(styles.container, containerClassName)} {...rest}>
      {navigation?.title && (
        <section className={styles.navigationContainer}>
          <Breadcrumb to={{ title: title ?? 'Account details' }} from={navigation} />
        </section>
      )}
      <header
        className={cx(utilityStyles.boldWeight, utilityStyles.mdFontSize, headerTextClassName)}>
        {header}
      </header>
      <section className={cx(styles.content, contentClassName)}>{content}</section>
    </section>
  )
}
